import { useEffect } from "react";
import CloseButton from "./CloseButton";
import "./modal.scss";
import classNames from "classnames";

function Modal({
  children,
  className,
  hideScrollBar = false,
  modalCloseButtonClick,
  positionRelative = false,
  showBackdrop = true,
  small = false,
  title,
  titleAsHeader = true,
  wrapperCustomClassName,
}) {
  useEffect(() => {
    positionRelative && document.body.classList.add("modal-open");
  }, [positionRelative]);

  const closeButtonClick = () => {
    // remove modal open class if there are no other modals open
    if (document.querySelectorAll(".modal").length <= 1) {
      document.body.classList.remove("modal-open");
    }
    if (modalCloseButtonClick !== null) {
      modalCloseButtonClick();
    }
  };

  return (
    <>
      {showBackdrop && (
        <div className="modal-backdrop fade show"></div>
      )}
      <div
        className={classNames(
          "modal",
          "d-block",
          !showBackdrop ? "pe-none no-backdrop" : "",
          small ? "modal-small" : "",
          positionRelative ? "position-relative" : "",
          hideScrollBar ? "overflow-hidden" : "",
          wrapperCustomClassName
        )}
        tabIndex="-1"
        aria-modal="true"
      >
        <div
          className={classNames(
            "modal-dialog",
            "modal-dialog-centered",
            !showBackdrop ? "pe-none" : "",
            className
          )}
          role="document"
        >
          <div className="modal-content">
            {(title || modalCloseButtonClick !== null) && (
              <div className="modal-header">
                {titleAsHeader ? (
                  <h3 className="modal-title">{title}</h3>
                ) : (
                  <p className="modal-title">{title}</p>
                )}
                {modalCloseButtonClick !== null && (
                  <CloseButton
                    className="float-end"
                    label="Close"
                    onClick={() => {
                      closeButtonClick();
                    }}
                  />
                )}
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;
